var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QScoreCard',{key:"QScoreCardSME",attrs:{"agent-code":_vm.agentCode,"filters":_vm.filters,"title":"SME","api-endpoint":"sme","drill-downLabel":"Agent Breakdown","drill-down-route":"Drilldown_SME","card-style":"production","format":"Currency"}},[_vm._v(" Note: APV of total reset application written. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }